import SliderComponent from '@components/shared/CustomSlider';
import NewSectionTitle from '@components/shared/NewSectionTitle';
import React from 'react';
import Image from 'next/image';

// members
import Abhijeeth from '@assets/alumni/Abhijeeth-VS.webp';
import Akash from '@assets/alumni/Akash-Kumar.webp';
import Ayesha from '@assets/alumni/Ayesha-Firdose.webp';
import Bharadwaj from '@assets/alumni/Bharadwaj-Narayanam.webp';
import Dany from '@assets/alumni/Dany-Chitturi.webp';
import Mahin from '@assets/alumni/Mahin-Sekaran.webp';
import Mihir from '@assets/alumni/Mihir-Gupta.webp';
import Sanjay from '@assets/alumni/Sanjay-Jaiswal.webp';
import Sayed from '@assets/alumni/Sayed-Ahmed.webp';
import Swathi from '@assets/alumni/Swathi-Hebbar.webp';

import { MdArrowBackIosNew, MdArrowForwardIos } from 'react-icons/md';
import { Primary, Secondary } from 'stories/Button.stories';
import { FaArrowRight } from 'react-icons/fa';
import { scrollToElement } from '@utils/functions/throttle';

// company logos
import Amazon from '@assets/Amazon.png';
import Target from '@assets/companies/target.webp';
import Exl from '@assets/companies/exl.webp';
import Groww from '@assets/companies/groww.webp';
import Noovartis from '@assets/companies/novartis.webp';
import TataSteel from '@assets/companies/tata-steel.webp';
import TechMahindra from '@assets/companies/tech-mahindra.webp';
import FreeCharge from '@assets/companies/freecharge.webp';

const academicUserData = [
  {
    name: 'Mihir Gupta',
    designation: 'Business Analyst',
    company: 'Amazon Pay',
    profileImage: Mihir,
    companyLogo: Amazon,
  },
  {
    name: 'Ayesha Firdose W',
    designation: 'Data Associate I',
    company: 'Amazon',
    profileImage: Ayesha,
    companyLogo: Amazon,
  },
  {
    name: 'Sayed Aziz Ahmed',
    designation: 'Product Ops Analyst',
    company: 'TARGET',
    profileImage: Sayed,
    companyLogo: Target,
  },
  {
    name: 'Bharadwaj Narayanam',
    designation: 'Business Analyst',
    company: 'EXL Analytics',
    profileImage: Bharadwaj,
    companyLogo: Exl,
  },
  {
    name: 'Mahin Arvind Chanthira',
    designation: 'Business Analyst',
    company: 'Groww',
    profileImage: Mahin,
    companyLogo: Groww,
  },
  {
    name: 'Abhijeeth VS',
    designation: 'Business Analyst',
    company: 'Novartis',
    profileImage: Abhijeeth,
    companyLogo: Noovartis,
  },
  {
    name: 'Swathi V Hebbar',
    designation: 'Analyst',
    company: 'Tata Steel',
    profileImage: Swathi,
    companyLogo: TataSteel,
  },
  {
    name: 'Sanjay Jaiswal',
    designation: 'Data Analyst',
    company: 'Tech Mahindra',
    profileImage: Sanjay,
    companyLogo: TechMahindra,
  },
  {
    name: 'Dany Cornelius ',
    designation: 'Data Scientist',
    company: 'Freecharge',
    profileImage: Dany,
    companyLogo: FreeCharge,
  },
  // {
  //   name: 'Akash Kumar',
  //   designation: 'BI Analyst',
  //   company: 'RBL Bank',
  //   profileImage: Akash,
  // },
];

function StudentTestimonials() {
  return (
    <div className="mb-px flex flex-col items-center gap-y-[63px] bg-[#121212] px-[16px] pt-[40px] pb-[52px] md:px-[124px] md:py-[112px]">
      <div className="flex flex-col items-center gap-y-[16px]">
        <NewSectionTitle text={'Our Top'} headingStyle={'text-white'} highlightedText={'Alumni'} />
        <p className="text-center font-satoshi-regular text-[14px] leading-[20px] text-[#A3A3A3] md:text-[18px] md:leading-7">
          Our students are working at the best companies. Hire them today!
        </p>
      </div>

      <div className="w-full">
        <SliderComponent
          swiperOptions={{
            breakpoints: {
              320: {
                slidesPerView: 1.5,
                spaceBetween: 16,
                slidesPerGroup: 1,
              },
              768: {
                slidesPerView: 2.5,
                spaceBetween: 18,
                slidesPerGroup: 2,
              },
              1024: {
                slidesPerView: 4,
                spaceBetween: 24,
                slidesPerGroup: 2,
              },
            },
          }}
          paginate
          buttonStyle={{
            buttonClass:
              'col-span-2 md:col-span-5 !bg-[#1A1A1A] !text-white !border-none hover:!bg-[#2B2B2B] rounded-full p-[16px]',
            leftButton: 'place-self-end',
            rightButton: 'place-self-start',
          }}
          paginationLayout="flex items-center gap-x-[12px] col-span-8 md:col-span-2 place-self-center justify-center"
          paginationClass="gray-out-pagination"
          spaceFromCarousel="100px"
          leftBtnElem={<MdArrowBackIosNew size={20} />}
          rightBtnElem={<MdArrowForwardIos size={20} />}
        >
          {academicUserData.map((item) => (
            <MemberCard key={item.name} {...item} />
          ))}
        </SliderComponent>
      </div>

      <div className="flex w-full items-center justify-center gap-x-[16px]">
        <Primary
          label={'Start Hiring'}
          size={'large'}
          customStyle="flex items-center gap-x-[8px]"
          onClick={() => scrollToElement('hireForm')}
        >
          <FaArrowRight size={20} className="mt-1" />
        </Primary>
        <Secondary
          label={'View Our Placement Record'}
          target="_blank"
          linkCTA
          href={'/placement-statistics'}
        />
      </div>
    </div>
  );
}

export default StudentTestimonials;

function MemberCard({ name, profileImage, designation, company, companyLogo }) {
  return (
    <div className="relative flex flex-col items-center">
      <Image
        src={profileImage}
        width={302}
        height={287}
        objectFit="cover"
        className="w-full rounded-lg"
        loading="lazy"
      />

      <div className="black-overlay--180deg absolute bottom-0 h-[80px] w-full"></div>

      <div className="absolute -bottom-16 flex h-[90px] w-[260px] cursor-pointer flex-col items-start gap-y-[8px] rounded bg-[#ffffff4d] p-[8px] backdrop-blur-md md:h-[130px] md:p-[16px]">
        <div className="flex flex-col">
          <h3 className="text-left font-satoshi-bold text-[16px] leading-6 text-white md:text-[20px] md:leading-[30px]">
            {name}
          </h3>
          <p className="text-left font-satoshi-medium text-[12px] leading-[18px] text-[#D0D0D0] line-clamp-2 hover:line-clamp-none md:text-[14px] md:leading-[20px]">
            {designation} at {company}
          </p>
        </div>
        <div>
          {companyLogo && (
            <div className="rounded-lg bg-white px-[8px] pt-[8px]">
              <Image src={companyLogo} height={32} width={64} objectFit="contain" />
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
